import type {
    CreateVerificationRequest,
    ReinitiateVerificationRequest,
    TreefortFileResponse,
    VerificationDetails,
    VerificationRequestResponse,
} from '@common/types/treefort';
import axiosInstance from './axiosInstance';

export async function createIDVerificationEmail(payload: CreateVerificationRequest) {
    return axiosInstance.post<TreefortFileResponse>('api/v1/treefort/create-verification', payload);
}

export async function getVerificationRequestResponse(prospectId: string) {
    return axiosInstance.get<VerificationRequestResponse[]>(
        `api/v1/treefort/verification-request-response/${prospectId}`,
    );
}

export async function createCancelIDVerification(clientRequestId: string) {
    return axiosInstance.post<string>(`api/v1/treefort/${clientRequestId}/cancel-verification`);
}

export async function createVerificationDetails(clientRequestId: string) {
    return axiosInstance.post<VerificationDetails | null>(
        `api/v1/treefort/${clientRequestId}/verification-details`,
    );
}

export async function reInitiateIDVerification(payload: ReinitiateVerificationRequest) {
    return axiosInstance.post<TreefortFileResponse>(
        'api/v1/treefort/ReInitiate-verification',
        payload,
    );
}

export async function updateIDVerification(
    clientRequestId: string,
    payload: CreateVerificationRequest,
) {
    return axiosInstance.post<TreefortFileResponse>(
        `api/v1/treefort/${clientRequestId}/recreate`,
        payload,
    );
}
